import { DatePipe } from '@angular/common';
import { Component, OnInit, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EntityPagedRequestParameters, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { AcompanhamentoProcessualOperacao } from 'src/app/model/acompanhamento-processual.model';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { STATUS_PROTOCOLO } from 'src/app/model/protocolo-arquivo.model';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_AGENTE_CONSULTA, ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA } from '../../../constantes/permissao.constants';
import { AcompanhamentoProcessualService } from './acompanhamento-processual.service';
import moment from "moment";
import Utils from 'src/app/shared/fgi-utils';

@Component({
    selector: 'app-acompanhamento-processual-pesquisa',
    templateUrl: './acompanhamento-processual-pesquisa.component.html',
    styleUrls: ['./acompanhamento-processual-pesquisa.component.scss'],
    standalone: false
})
export class AcompanhamentoProcessualPesquisaComponent implements OnInit {

  private atributosPaginacaoComponenteListagem: EntityPagedResult<AcompanhamentoProcessualOperacao>;
  public atributosPaginacao: EntityPagedRequestParameters;
  public agentesFinanceiros: AgenteFinanceiro[];
  public acompanhamentosOperacao: AcompanhamentoProcessualOperacao[];
  public cnpjUsuario: string;
  public podeEnviar: boolean;
  public podeEscolherAgente: boolean;
  public ehAgenteFinanceiro: boolean = false;
  
  public valoresStatusProtocolo = STATUS_PROTOCOLO;
  public pesquisaForm: UntypedFormGroup;
  public valoresPesquisaForm: any;
  private opcoesPaginacao: number[];
  public pesquisado: boolean = false;
  public esconderPesquisa: boolean = true;
  public podeListarOperacoes: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private acompanhamentoProcessualService: AcompanhamentoProcessualService,
    private permissaoService: PermissaoService,
    private bnUsuarioService: BnUsuarioService,
    private formBuilder: UntypedFormBuilder,
    private datePipe: DatePipe,
    private fileUtils: FileUtilsService) {
    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
    this.opcoesPaginacao = [10, 15, 20];

    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };
  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.buscar();
  }

  ngOnInit() {
    this.pesquisaForm = this.createReactiveForm();

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
      this.podeEnviar = resp && resp[ROLE_AGENTE_ENVIO];
      this.ehAgenteFinanceiro = resp && resp[ROLE_AGENTE_CONSULTA];

      this.acompanhamentoProcessualService.getTimeStampISO().subscribe((ts: any) => {
        const momentoAtual = moment(ts ? 
          Utils.dataFromISO(ts.nowDateISO) : Utils.dataCorrente()).startOf('day');

        this.acompanhamentoProcessualService.getJanelaAtual().subscribe((resp) => {
          this.podeListarOperacoes = resp && !momentoAtual.isBefore(moment(resp.dataInicioListagemOperacoes).startOf('day'));
          this.podeEnviar = this.podeEnviar && resp && !momentoAtual.isBefore(moment(resp.dataAbertura).startOf('day')) && !momentoAtual.isAfter(moment(resp.dataFechamento).endOf('day'));
        });
      });

      this.bnUsuarioService.usuario$.subscribe(usuario => {
        this.cnpjUsuario = usuario.cnpj;
        this.construirFormulario();
      });
    });
  }

  private validarCnpjUsuarioLogado(){
    if(this.podeEscolherAgente){
      return null;
    }

    return this.agentesFinanceiros.filter(a => a.cnpj === this.cnpjUsuario)[0]?.cnpj || null;
  }

  private construirFormulario() {

    const valoresSessao = sessionStorage.getItem('valoresPesquisaAcompanhamentoOperacaoForm');
    this.valoresPesquisaForm = valoresSessao ? JSON.parse(valoresSessao) : null;

    if (this.valoresPesquisaForm) {
      this.pesquisaForm.patchValue({
        cnpjAgenteFinanceiro: this.validarCnpjUsuarioLogado(),
        sistema: this.valoresPesquisaForm.sistema ? this.valoresPesquisaForm.sistema : null,
        contrato: this.valoresPesquisaForm.contrato ? this.valoresPesquisaForm.contrato : null,
        idAcompanhamento: this.valoresPesquisaForm.idAcompanhamento ? this.valoresPesquisaForm.idAcompanhamento : null,
        idExternoOperacao: this.valoresPesquisaForm.idExternoOperacao ? this.valoresPesquisaForm.idExternoOperacao : null,
        dataEnvioInicial: this.valoresPesquisaForm.dataEnvioInicial ? this.valoresPesquisaForm.dataEnvioInicial : null,
        dataEnvioFinal: this.valoresPesquisaForm.dataEnvioFinal ? this.valoresPesquisaForm.dataEnvioFinal : null,
        statusProtocolo: this.valoresPesquisaForm.statusProtocolo ? this.valoresPesquisaForm.statusProtocolo : null
      });

    }
    if (!this.podeEscolherAgente) {
      this.pesquisaForm.patchValue({ cnpjAgenteFinanceiro: this.cnpjUsuario });
      this.pesquisaForm.controls.cnpjAgenteFinanceiro.disable();
    }
    this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
      this.valoresPesquisaForm = novosValores;
      this.pesquisado = false;
      sessionStorage.setItem('valoresPesquisaAcompanhamentoOperacaoForm', JSON.stringify(this.valoresPesquisaForm));
    });
  }

  downloadOperacoesQuePrecisamSerInformadas() {
    const form = this.pesquisaForm.getRawValue();
    this.acompanhamentoProcessualService.getOperacoesQuePrecisamSerInformadas(form.cnpjAgenteFinanceiro).subscribe((resp) => {
      let csv = "idOperacaoAgenteCreditoLivre;sistemaRepasse;contratoRepasse\n";

      for (let operacao of resp.operacoes) {
        csv += (operacao.idOperacaoAgenteCreditoLivre || '') + ";" + (operacao.sistemaRepasse || '') + ";" + (operacao.contratoRepasse || '') + "\n";
      }

      this.fileUtils.exportarArquivo('operacoes_para_informacao.csv',
      csv, FileUtilsService.TEXT_CSV);
    });
  }

  agenteFinanceiroSelecionado() {
    const form = this.pesquisaForm.getRawValue();
    return form.cnpjAgenteFinanceiro != null;
  }

  createReactiveForm(): UntypedFormGroup {

    const form = this.formBuilder.group({
      cnpjAgenteFinanceiro: null,
      dataEnvioInicial: null,
      dataEnvioFinal: null,
      idAcompanhamento:null,
      sistema: null,
      idExternoOperacao: [null, [Validators.pattern(/^[A-Za-z0-9_\-]+$/), Validators.minLength(1), Validators.maxLength(20)]],
      contrato: [null, [Validators.pattern(/^[0-9]+$/), Validators.minLength(11), Validators.maxLength(11)]],
      statusProtocolo: null
    });

    form.get('sistema').valueChanges.subscribe(sist => {
      const contrato = form.get('contrato');
      const idExternoOperacao = form.get('idExternoOperacao');
      if (!sist) {
        idExternoOperacao.enable();
        contrato.enable();
        return;
      }
      if (sist === 'CL') {
        idExternoOperacao.enable();
        contrato.disable();
      } else {
        contrato.enable();
        idExternoOperacao.disable();
      }
      contrato.updateValueAndValidity();
      idExternoOperacao.updateValueAndValidity();
    });

    return form;
  }

  getParams() {
    const form = this.pesquisaForm.getRawValue();
    let params: any = {};

    if (form.cnpjAgenteFinanceiro) {
      params.cnpjAgenteFinanceiro = form.cnpjAgenteFinanceiro;
    }
    if (form.dataEnvioInicial) {
      params.dataEnvioInicial = this.datePipe.transform(form.dataEnvioInicial,'yyyyMMdd');
    }
    if (form.dataEnvioFinal) {
      params.dataEnvioFinal = this.datePipe.transform(form.dataEnvioFinal, 'yyyyMMdd');
    }
    if (form.idAcompanhamento) {
      params.idAcompanhamento = form.idAcompanhamento;
    }
    if (form.sistema) {
      params.sistema = form.sistema;
    }
    if (form.idExternoOperacao) {
      params.idExternoOperacao = form.idExternoOperacao;
    }
    if (form.contrato) {
      params.contrato = form.contrato;
    }
    if (form.statusProtocolo) {
      params.statusProtocolo = form.statusProtocolo;
    }
    params.pagina = this.atributosPaginacaoComponenteListagem.page;
    params.limite = this.atributosPaginacaoComponenteListagem.pageSize;

    return params;
  }

  buscar() {
    this.esconderPesquisa = true;

    if (!this.pesquisado) {
      this.atributosPaginacaoComponenteListagem.page = 1;
    }
    this.acompanhamentoProcessualService.getAcompanhamentos(this.getParams()).subscribe(resp => {
      this.acompanhamentosOperacao = resp.resultados;
      this.atributosPaginacaoComponenteListagem.count = resp ? resp.totalRegistrosSemPaginacao : 0;
      this.pesquisado = true;
      this.esconderPesquisa = false;
    });
  }

  limpar() {
    this.pesquisado = false;
    this.pesquisaForm.reset();
    this.pesquisaForm.patchValue({ cnpjAgenteFinanceiro: this.validarCnpjUsuarioLogado() });
    if (!this.podeEscolherAgente) {
      this.pesquisaForm.controls.cnpjAgenteFinanceiro.disable();
    }
  }

  mudancaPagina(novaPagina: EntityPagedResult<AcompanhamentoProcessualOperacao>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar();
  }

}